import script from "./MDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./MDropdown.vue?vue&type=script&lang=ts&setup=true"

import "./MDropdown.vue?vue&type=style&index=0&id=61657cc9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61657cc9"]])

export default __exports__